import styled from 'styled-components';

// Logout Confirmation Container
export const StyledLogoutConfirmation = styled.div`
  padding: var(--spacing-6);
`;

// Confirmation Text
export const StyledConfirmationText = styled.p`
  color: var(--color-gray-600);
  font-size: var(--font-size-14);
  line-height: var(--line-height-relaxed);
  margin: 0 0 var(--spacing-6) 0;
`;

// Action Buttons Container
export const StyledActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3);
`;

// Warning Icon Container
export const StyledWarningIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-12);
  height: var(--spacing-12);
  background-color: var(--color-warning-100);
  border-radius: var(--radius-full);
  margin: 0 auto var(--spacing-4) auto;

  svg {
    color: var(--color-warning-600);
  }
`;

// Confirmation Content
export const StyledConfirmationContent = styled.div`
  text-align: center;

  h3 {
    font-size: var(--font-size-18);
    font-weight: var(--font-weight-semibold);
    color: var(--color-gray-900);
    margin: 0 0 var(--spacing-2) 0;
  }
`;
